import React, { Component } from 'react';
import ReactStars from 'react-rating-stars-component';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

class PurchasesFeedbackComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  closeModal = () => this.props.closeModal();

  render() {
    const { items } = this.props;

    return (
      <div className="row justify-content-center">
        <div className="orders-modal-main-feedback">
          <div>
            <span className="title-order-details">
              {I18n.t('feedbackDetails')}
            </span>

            <div className="feedback-score">
              <span style={{ paddingRight: '10px' }}>
                <strong>{I18n.t('userFeedbackScore')}</strong>
              </span>

              <ReactStars
                count={5}
                size={28}
                edit={false}
                activeColor="#ffd700"
                value={items.websiteReviewScore}
              />
            </div>

            <div className="feedback-opinion">
              <span className="feedback-opinion-title">
                <strong>{I18n.t('userFeedbackTitle')}</strong>
              </span>

              <span className="feedback-opinion-text">
                {items.feedbackText}
              </span>
            </div>
          </div>

          <div className="feedback-button-close">
            <button
              type="button"
              className="btn btn-danger"
              onClick={this.closeModal}
            >
              {I18n.t('close')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyTag: state.settings && state.settings.companyTag,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesFeedbackComponent);
